import { useEffect, useState } from 'react';
import { useApi } from '../../hooks/useApi';
import styles from './accessGrants.module.css';
import { useStores } from '../../hooks/useStore';
import { observer } from 'mobx-react';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { Button } from '../../components/UI/Button/Button';
import { Input } from '../../components/UI/input/input';
import { AppUser } from '../../models/appUser';
import GrantAccessPopUP from '../../components/popUp/GrantAccess/GrantAccess';

const AccessGrants: React.FC = observer(() => {
  const api = useApi();
  const store = useStores();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [users, setUsers] = useState<AppUser[]>([]);
  const [total, setTotal] = useState<number>(0);

  const [searchText, setSearchText] = useState<string>('');

  const [selectedUser, setSelectedUser] = useState<AppUser | null>(null);

  useEffect(() => {
    loadUsers();
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (searchText.length > 2 || searchText.length === 0) {
      setPage(0);
      loadUsers();
    }
  }, [searchText]);

  const loadUsers = async () => {
    try {
      store.notificationsStore.showPreloader();

      const search =
        searchText !== '' && searchText.length > 2 ? searchText : '';

      const resp = await api.accessGrants.searchUsers(
        search,
        page * rowsPerPage,
        rowsPerPage,
      );

      if (resp.body) {
        setUsers(resp.body);
      }

      setTotal(resp.total ?? 0);
    } catch (e) {
      store.notificationsStore.setError('Ошибка при загрузке пользователей');
    } finally {
      store.notificationsStore.hidePreloader();
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      {selectedUser && (
        <GrantAccessPopUP
          user={selectedUser}
          onClose={() => setSelectedUser(null)}
        />
      )}
      <div className={styles.container}>
        <div className={styles.pageName}>
          <div className={styles.top}>
            <div className={styles.title}>
              <h2>Доступы к курсам</h2>
            </div>
            <Input
              textLabel="Поиск по имени или email"
              placeholder="Поиск по имени или email"
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <p className={styles.hint}>
            Найдите пользователя приложения и выдайте ему доступ к курсу.
          </p>
        </div>

        <div style={{ width: '100%', maxWidth: 1500, margin: '5px' }}>
          <Paper
            sx={{
              width: '100%',
              maxWidth: 1500,
              margin: '5px',
              overflowX: 'auto',
            }}
          >
            <TableContainer style={{ marginTop: 20, overflowX: 'auto' }}>
              <Table sx={{ minWidth: 320 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Имя</TableCell>
                    <TableCell align="right">Email</TableCell>
                    <TableCell align="right">Доступы</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users &&
                    users.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.name ? row.name : 'Имя не указано'}
                        </TableCell>
                        <TableCell align="right">{row.email}</TableCell>
                        <TableCell align="right">
                          <Button
                            style={{ width: 200 }}
                            appearance="link"
                            onClick={() => setSelectedUser(row)}
                          >
                            Управление доступами
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div
              style={{ width: '100%', height: 1, backgroundColor: '#E0E0E0' }}
            />
            <TablePagination
              labelRowsPerPage="Строк на странице"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} из ${count !== -1 ? count : `больше чем ${to}`}`
              }
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </div>
    </>
  );
});

export default AccessGrants;
